module.exports = "/images/chat-active.svg?8652aeb923e16615013b87dde6b1a373";